import { Button, Stack } from '@mui/material';
import { CreditCard } from 'lucide-react';
import { useId, useState } from 'react';
import { FormFieldLabel } from 'src/components/Forms/FormFieldLabel/form-field-label';
import { SelectMenu, type SelectMenuOption } from 'src/components/SelectMenu';
import { SettingsSectionRow } from 'src/components/SettingsSection';
import { SUPPORTED_COUNTRIES } from './constants';
import { useStripeAccountOnboardUrl } from './use-stripe-account-onboard-url';

const COUNTRY_OPTIONS: SelectMenuOption[] = SUPPORTED_COUNTRIES.map(({ value, label }) => ({
  value,
  title: label,
}));

/**
 * Row shown when the partner has no Stripe account yet: pick a country and
 * hand off to Stripe-hosted onboarding.
 */
export const StripeSetupRow = () => {
  const { redirectToStripeOnboard, loading } = useStripeAccountOnboardUrl();
  const [country, setCountry] = useState<string>('US');
  const countryTriggerId = useId();

  return (
    <SettingsSectionRow
      icon={<CreditCard />}
      title="Stripe Express account"
      secondary="You'll be redirected to Stripe to complete onboarding."
      control={
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'flex-end' }}
          gap={1.5}
        >
          <Stack sx={{ minWidth: (theme) => theme.typography.pxToRem(180) }}>
            <FormFieldLabel htmlFor={countryTriggerId}>Country</FormFieldLabel>
            <SelectMenu
              id={countryTriggerId}
              label="Country"
              variant="field"
              menuWidth="trigger"
              options={COUNTRY_OPTIONS}
              value={country}
              onChange={setCountry}
            />
          </Stack>
          <Button
            variant="contained"
            onClick={() => void redirectToStripeOnboard(country)}
            disabled={loading}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {loading ? 'Connecting...' : 'Connect with Stripe'}
          </Button>
        </Stack>
      }
      controlAlign="center"
      mobileControlLayout="below"
    />
  );
};
